import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InsuranceComponent } from './insurance.component';
import { InsuranceCarriersSubscribersComponent } from './insurance-carriers-subscribers/insurance-carriers-subscribers.component';
import { InsuranceManagementComponent } from './insurance-management/insurance-management.component';
import { InsuranceManageSubscribersComponent } from './insurance-manage-subscribers/insurance-manage-subscribers.component';
import { InsuranceCoverageComponent } from './insurance-coverage/insurance-coverage.component';
import { InsuranceProfileComponent } from './insurance-profile/insurance-profile.component';

const routes: Routes = [{
  path: '', component: InsuranceComponent,
  children: [
    { path: 'insurance-carriers-subscribers', component: InsuranceCarriersSubscribersComponent },
    { path: 'insurance-management', component: InsuranceManagementComponent },
    { path: 'insurance-manage-subscribers', component: InsuranceManageSubscribersComponent },
    { path: 'insurance-coverage', component: InsuranceCoverageComponent },
    { path: 'insurance-profile', component: InsuranceProfileComponent },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
  })
export class InsuranceRoutingModule { }
